import request from './client';

export function getSessionProfile(email) {
  
  return request({
    method: 'GET',
    url: '/api/v1/session/profile',
    responseType: 'json'
  });

}  

export function getSession() {

  return request({
    method: 'GET',
    url: '/api/v1/session',
    responseType: 'json'
  });

}

export function putProfile(data) {
  return request({
    method: 'PUT',
    url: '/api/v1/session/profile',
    data: data,
    responseType: 'json'
  });
}

export function putProperty(data) {
  return request({
    method: 'PUT',
    url: '/api/v1/session/property',
    data: data,
    responseType: 'json'
  });
}


// WEBPACK FOOTER //
// ./src/gateways/session.js